var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.128 367.325H35.2379C29.6796 367.325 25.17 362.816 25.17 357.257V165.756H453.584V190.926C453.584 197.847 459.247 203.511 466.169 203.511C473.09 203.511 478.754 197.847 478.754 190.926V100.209C478.754 80.8071 462.918 64.971 443.516 64.971H35.2379C15.7312 64.971 0 80.8071 0 100.209V357.257C0 376.659 15.8361 392.495 35.2379 392.495H278.233C285.155 392.495 290.818 386.832 290.818 379.91C290.818 372.988 285.155 367.325 278.128 367.325ZM35.2379 90.141H443.516C449.074 90.141 453.584 94.6506 453.584 100.209V140.586H25.0651V100.209C25.0651 94.6506 29.6796 90.141 35.2379 90.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.909 259.199C251.909 252.277 246.246 246.614 239.324 246.614H88.0949C81.1731 246.614 75.5099 252.277 75.5099 259.199C75.5099 266.121 81.1731 271.784 88.0949 271.784H239.324C246.351 271.784 251.909 266.121 251.909 259.199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0949 291.71C81.1731 291.71 75.5099 297.374 75.5099 304.295C75.5099 311.217 81.1731 316.88 88.0949 316.88H148.608C155.529 316.88 161.193 311.217 161.193 304.295C161.193 297.374 155.529 291.71 148.608 291.71H88.0949Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6266 226.164H237.856C244.778 226.164 250.441 220.5 250.441 213.579C250.441 206.657 244.778 200.994 237.856 200.994H86.6266C79.7049 200.994 74.0416 206.657 74.0416 213.579C74.0416 220.5 79.6 226.164 86.6266 226.164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.519 312.79H481.061V283.425C481.061 247.034 451.381 217.354 414.99 217.354C378.598 217.354 348.919 247.034 348.919 283.425V312.79H330.461C323.539 312.79 317.876 318.453 317.876 325.375V434.445C317.876 441.367 323.539 447.03 330.461 447.03H499.414C506.336 447.03 511.999 441.367 511.999 434.445V325.375C512.104 318.349 506.441 312.79 499.519 312.79ZM374.089 283.32C374.089 260.772 392.442 242.419 414.99 242.419C437.538 242.419 455.891 260.772 455.891 283.32V312.685H374.089V283.32ZM486.934 421.755H343.046V337.855H486.829V421.755H486.934Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2c8f2423fe7a0f6d8fd1c8db950f416f.svg";
export { ForwardRef as ReactComponent };